// extracted by mini-css-extract-plugin
module.exports = {"container":"c6e8ba5398--container--1thlj","title":"c6e8ba5398--title--226K1","tooltip-container":"c6e8ba5398--tooltip-container--losks","info-icon":"c6e8ba5398--info-icon--2uJjR"};